import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import FilterByMonthYear from "../../Filters/FilterByMonthYear";
import RateHistoryTable from "./OfferTables/RateHistoryTable";
import ApplicantOfferApplicationTable from "./OfferTables/ApplicantOfferApplicationTable";
import ApplicantOfferOnOfferTable from "./OfferTables/ApplicantOfferOnOfferTable";
import ApplicantOfferCredentialTable from "./OfferTables/ApplicantOfferCredentialTable";
import ApplicantOfferPolicyTable from "./OfferTables/ApplicantOfferPolicyTable";
import ApplicantOfferOrientationTable from "./OfferTables/ApplicantOfferOrientationTable";
import ApplicantOfferEvaluationTable from "./OfferTables/ApplicantOfferEvaluationTable";
import ApplicantOfferTrainingTable from "./OfferTables/ApplicantOfferTrainingTable";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OfferTabs() {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="flex mt-8 mb-8">
      <Box sx={{ width: "100%" }}>
        <div className="bg-white rounded pb-[1.5rem]">
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons={true}
              sx={{
                "& .MuiTabs-flexContainer": {
                  [theme.breakpoints.only("xs")]: {
                    flexWrap: "wrap",
                  },
                },
              }}
            >
              <Tab
                label="Rate History"
                {...a11yProps(0)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Application"
                {...a11yProps(1)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Offer"
                {...a11yProps(2)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />

              <Tab
                label="Credentials"
                {...a11yProps(3)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Policy & Agreement"
                {...a11yProps(4)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Orientation Topics"
                {...a11yProps(5)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Evaluation"
                {...a11yProps(6)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
              <Tab
                label="Quarterly Trainings"
                {...a11yProps(7)}
                style={{
                  paddingLeft: "1.5rem",
                  paddingRight: "1.5rem",
                  paddingTop: "16px",
                }}
                iconPosition="end"
              />
            </Tabs>
          </Box>
          <section className="flex justify-end mt-[30.5px] mb-[24px]  pr-4">
            {(value === 0 || value === 6 || value === 7) && (
              <FilterByMonthYear />
            )}
          </section>
        </div>

        <CustomTabPanel value={value} index={0}>
          <RateHistoryTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ApplicantOfferApplicationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <ApplicantOfferOnOfferTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <ApplicantOfferCredentialTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <ApplicantOfferPolicyTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={5}>
          <ApplicantOfferOrientationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={6}>
          <ApplicantOfferEvaluationTable />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={7}>
          <ApplicantOfferTrainingTable />
        </CustomTabPanel>
      </Box>
    </div>
  );
}
